import { Download, FileText } from 'lucide-react';

import { Button } from '@/ui/primitives/button';
import { type DocumentoDetalhe } from '@fiscoai/contracts';

import { abrirDanfe, baixarXml } from './api';
import { useAcao } from './use-acao';

/** DANFE (nova aba) e XML original — só para quem pode baixar documentos. */
export function AcoesDocumento({ doc }: { doc: DocumentoDetalhe }) {
  const danfe = useAcao(() => abrirDanfe(doc.id));
  const xml = useAcao(() => baixarXml(doc.id, doc.chave));
  return (
    <div className="flex flex-wrap gap-2">
      <Button tamanho="sm" onClick={danfe.disparar} carregando={danfe.ocupado}>
        <FileText aria-hidden />
        Ver DANFE
      </Button>
      <Button tamanho="sm" variante="fantasma" onClick={xml.disparar} carregando={xml.ocupado}>
        <Download aria-hidden />
        Baixar XML
      </Button>
    </div>
  );
}
